"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var BenefitComponent = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var configuration = props.configuration,
      flexTitle = props.flexTitle,
      style = props.style,
      _a = props.maxImgWidth,
      maxImgWidth = _a === void 0 ? '' : _a,
      restProps = __rest(props, ["configuration", "flexTitle", "style", "maxImgWidth"]);

  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'flex-default-benefit-class-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-benefit-class-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), configuration ? configuration.map(function (item, index) {
    var _a = item || {},
        imageSrc = _a.imageSrc,
        article = _a.article;

    var _b = (0, _utils.fomateFileData)(imageSrc),
        url = _b.url,
        _c = _b.alt,
        alt = _c === void 0 ? '' : _c;

    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "flex-default-benefit-class-container-children__section " + (index % 2 !== 0 && 'flex-default-benefit-class-container-children__section--reversal'),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-benefit-class-container-children__section__left'
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: url,
      alt: alt,
      style: maxImgWidth ? {
        maxWidth: maxImgWidth
      } : {}
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-default-benefit-class-container-children__section__right"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-default-benefit-class-container-children__section__right--href__container'
    }, /*#__PURE__*/_react["default"].createElement("article", {
      dangerouslySetInnerHTML: {
        __html: article || ''
      }
    }))));
  }) : null));
});
BenefitComponent.displayName = 'TCIBenefitComponent';
var _default = BenefitComponent;
exports["default"] = _default;